import { Component, computed, inject, input, output } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { ProgramMiniDto, ProgramsClient, UnityWorkflowState } from '@unity/clients';
import { DropdownControlComponent } from '@unity/forms/dropdown-control/dropdown-control.component';

@Component({
  selector: 'unity-dropdown-program-control',
  standalone: true,
  imports: [KENDO_DROPDOWNS, KENDO_FORMFIELD, KENDO_LABEL, ReactiveFormsModule, DropdownControlComponent],
  templateUrl: './dropdown-program-control.component.html',
  styleUrl: './dropdown-program-control.component.scss',
})
export class DropdownProgramControlComponent {
  private readonly programsClient = inject(ProgramsClient);

  private allProgramsResource = rxResource({
    stream: () => this.programsClient.getAllAsDetailed(),
  });

  protected readonly $enabledPrograms = computed(() => {
    if (!this.allProgramsResource.hasValue()) {
      return [];
    }
    const allPrograms = this.allProgramsResource.value().data;
    return allPrograms.filter(x => x.current_state.enum_value !== UnityWorkflowState.Disabled);
  });

  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $defaultItem = input<{ name: string; id: unknown }>({ name: '', id: null }, { alias: 'defaultItem' });
  public readonly $showHint = input(true, { alias: 'showHint' });

  public selectionChangeEvent = output<ProgramMiniDto>();

  protected onSelectionChange(event: unknown) {
    this.selectionChangeEvent.emit(event as ProgramMiniDto);
  }
}
